import ClientSidebar from "../components/portal/ClientSidebar";
import ClientTopBar from "../components/portal/ClientTopBar";
import Chat from "./chat";

// Client-portal Inbox: project-aware conversation workspace in the Client
// Workspace chrome. The shared h-16 top bar aligns with the Chat page's
// h-[calc(100vh-4rem)] so there's no empty gap.
const ClientInboxPage = () => (
  <div className="h-screen overflow-hidden bg-[#f8f9ff] text-on-surface flex">
    <ClientSidebar active="inbox" />
    <div className="flex-1 min-w-0 flex flex-col">
      <ClientTopBar title="Inbox" />
      <div className="flex-1 min-h-0">
        <Chat embedded />
      </div>
    </div>
  </div>
);

export default ClientInboxPage;
